import { Title } from '@smart-kasa/ui';

import styles from './Report.module.scss';

export const ReportTitle = (props) => <Title className={styles.title} {...props} />;
